import { Link } from "react-router-dom";

/** Lenke-brikke under en systemmelding, f.eks. til budsjettet på prosjektkortet (VIB-3026). */
export function SystemMessageLink({ link }: { link: { kind: string; label: string; href: string } }) {
  return (
    <Link
      to={link.href}
      className="inline-flex h-[30px] items-center gap-2 self-start rounded-lg border-[1.5px] border-border bg-[hsl(var(--surface-light))] px-2.5 text-[13px] text-foreground hover:bg-secondary"
    >
      <span className="text-[11px] font-semibold uppercase tracking-[0.06em] text-primary">{link.kind}</span>
      {link.label}
    </Link>
  );
}
